"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderCustomLocation = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const OrderLocationVehicleTypePriceFee_1 = require("./OrderLocationVehicleTypePriceFee");
const Position_1 = require("./Position");
let OrderCustomLocation = class OrderCustomLocation {
    title;
    position;
    duration;
    order;
    countryId;
    vehicleTypesPricesFees = [];
};
exports.OrderCustomLocation = OrderCustomLocation;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OrderCustomLocation.prototype, "title", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Position_1.Position),
    __metadata("design:type", Position_1.Position)
], OrderCustomLocation.prototype, "position", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCustomLocation.prototype, "duration", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderCustomLocation.prototype, "order", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], OrderCustomLocation.prototype, "countryId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [OrderLocationVehicleTypePriceFee_1.OrderLocationVehicleTypePriceFee]),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderLocationVehicleTypePriceFee_1.OrderLocationVehicleTypePriceFee),
    __metadata("design:type", Array)
], OrderCustomLocation.prototype, "vehicleTypesPricesFees", void 0);
exports.OrderCustomLocation = OrderCustomLocation = __decorate([
    (0, type_graphql_1.ObjectType)("OrderCustomLocation"),
    (0, type_graphql_1.InputType)("OrderCustomLocationInput"),
    (0, class_transformer_1.Exclude)()
], OrderCustomLocation);
//# sourceMappingURL=OrderCustomLocation.js.map